/**
 * Configuration
 */
(function () {
	var app = angular.module('app');

	app.config(configure);
	app.config(toastrConfig);

	toastrConfig.$inject = ['toastr'];
	function toastrConfig(toastr) {
		toastr.options.timeOut = 4000;
		toastr.options.positionClass = 'toast-bottom-right';
	}

	var config = {
		appErrorPrefix: 'SSO Error: ', //Configure the exceptionHandler decorator
		appTitle: 'SSO',
		version: '0.1.0'
	};
	app.value('config', config);

	configure.$inject = ['$logProvider', '$routeProvider', 'routehelperConfigProvider', '$httpProvider', 'exceptionHandlerProvider'];
	function configure($logProvider, $routeProvider, routehelperConfigProvider, $httpProvider, exceptionHandler) {
		// turn debugging off/on (no info or warn)
		if ($logProvider.debugEnabled) {
			$logProvider.debugEnabled(true);
		}

		// Configure the common route provider
		routehelperConfigProvider.config.$routeProvider = $routeProvider;
		routehelperConfigProvider.config.docTitle = 'SSO: ';

		var resolveAlways = {
			/* @ngInject */
			ready: function () {
				return true;
			}
		};
		routehelperConfigProvider.config.resolveAlways = resolveAlways;

		// Configure the common exception handler
		exceptionHandler.configure(config.appErrorPrefix);
	}

	app.config(function ($httpProvider) {

	});

	app.run(["authentication", "$location", "$rootScope", 'authenticationSettings', function (authentication, $location, $rootScope, authenticationSettings) {
		var referrer = document.referrer;
		if (authenticationSettings.ssoUrl.indexOf(referrer) > -1) {
			referrer = authenticationSettings.defaultRedirectUrl; // use default URL to redirect to if the referrer is the SSO site itself
		}

		// stores where the request to log in is coming from
		$rootScope.redirectURL = $location.search().redirect || referrer;

		// populates auth data from cookie
		authentication.fillAuthData();
		$location.path($location.path());
	}]);

})();

